import { render, staticRenderFns } from "./MergeKidDialog.vue?vue&type=template&id=5de7d19e&scoped=true"
import script from "./MergeKidDialog.vue?vue&type=script&lang=js"
export * from "./MergeKidDialog.vue?vue&type=script&lang=js"
import style0 from "./MergeKidDialog.vue?vue&type=style&index=0&id=5de7d19e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de7d19e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5de7d19e')) {
      api.createRecord('5de7d19e', component.options)
    } else {
      api.reload('5de7d19e', component.options)
    }
    module.hot.accept("./MergeKidDialog.vue?vue&type=template&id=5de7d19e&scoped=true", function () {
      api.rerender('5de7d19e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/school/MergeKidDialog.vue"
export default component.exports